import $ from 'jquery';
import 'bootstrap';
import DataService from './DataService';
import Layout from './Layout';
let layout = new Layout();

let refreshContent = async () => {
	const dataService = new DataService();
	const id = window.location.hash.replace('#', '');

	const data = await dataService.get('contents', id);
	$('.orientation-notification').remove();
	data.attachments = data.attachments || [];
	$('[data-bind]').each((index, element) => {
		const key = $(element).data('bind');
		let content = data[key];
		if (key === 'content') {
			content = layout.addDntParamToAllExternalResourcesInContent(content);
		}

		$(element).html(content);
		const contentAsText = $(content).text();
		if (key === 'excerpt' && !contentAsText) {
			$(element).hide().next('hr').hide();
		}
	});

	layout.initCards();

	document.querySelectorAll('a[href^="http"]').forEach((anchor) => {
		anchor.setAttribute('target', '_blank');
	});
};

window.addEventListener('hashchange', refreshContent, false);
window.addEventListener('load', refreshContent, false);
